<template>
    <transition name="fade">
        <preloader-data v-if="loadDataStatus" />
    </transition>
    <router-view></router-view>
    <modal-win
        v-if="!loadDataStatus && showPayWin"
        :showDef="showPayWin"
        type="success"
        ref="modalSuccess"
        modalClass="modal-success"
    />
    <modal-win
        type="phoneRegistration"
        ref="modalPhoneRegistration"
    />
</template>

<script>

export default {
    data() {
        return {
            
        }
    },
    computed: {
        showPayWin() {
            return this.$store.state.showPayWin
        },
        loadDataStatus() {
            if (this.$store.state.status401 == 401) {
                this.$store.commit('logout')
                window.location.reload()
            }

            return this.$store.state.loadDataStatus
        }
    },
    watch: {
        '$route.query.show_phone_reg': {
            immediate: true,
            handler(val) {
                if (val && !this.loadDataStatus && this.$store.state.accounts.length) {
                    this.$nextTick(() => {
                        if (this.$refs.modalPhoneRegistration) {
                            this.$refs.modalPhoneRegistration.showModal()
                        }
                    })
                }
            }
        },
        loadDataStatus: {
            handler(val) {
                if (!val && this.$route.query.show_phone_reg && this.$store.state.accounts.length) {
                    this.$nextTick(() => {
                        if (this.$refs.modalPhoneRegistration) {
                            this.$refs.modalPhoneRegistration.showModal()
                        }
                    })
                }
            }
        }
    },
    mounted() {
        // this.$refs.modalSuccess.showModal()

        if (localStorage.getItem('token'))
            this.$store.commit('reloadPageSetValue')
        else {
            let code
            if (window.location.pathname.match(/^\/oldlogin\/?$/)){
                const searchParams = new URLSearchParams(window.location.search);
                code = searchParams.get('code');
            }
            if(code) 
                this.$router.push(`/oldlogin/?code=${code}`)
            else {
                const path = window.location.pathname
                if (path !== '/auth/' && path !== '/auth_mp/')
                    this.$router.push('/auth/')
            }
        }

        window.addEventListener('offline', function(e) {
            console.log('offline');
        });

        window.addEventListener('online', function(e) {
            console.log('online');
        });
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
